export const onEdgesDeleteCallback =
  ({ api, edges }) =>
  (deletedEdges) => {
    for (var k = 0; k < deletedEdges.length; k++) {
      const edge = deletedEdges[k];
      var edgeId = edge.data?.edgeId;
      if (!edgeId) {
        edgeId = edges.find((e) => e.id === edge.id)?.data?.edgeId;
      }
      if (edgeId) {
        api.flowEdge.delete(edgeId);
      }
    }
  };
